<script lang="ts" setup>
import DirectionColumnIfMobileContainer from '../../DirectionColumnIfMobileContainer.vue';
import ResearchDataCard from '../../ResearchData/ResearchDataCard.vue';
import Img1 from '/home/runner/_work/shadow/shadow/packages/app/node_modules/.cache/home/runner/_work/shadow/shadow/packages/app/src/components/templates/ProductLpTemplate/mortgage/ResearchDataCard/5.jpeg/5.webp';
import PinchImageModal from '~theme/components/organisms/PinchImageModal.vue';

defineProps<{
  num: number;
}>();
</script>

<template>
  <ResearchDataCard :num="num" :class="$style.container">
    <template #title>
      <strong>3人に1人は「マイホーム購入時の自己資金1割未満」</strong>
    </template>
    <DirectionColumnIfMobileContainer>
      <PinchImageModal :src="Img1" alt="グラフ" />
      <div>
        <p>
          既にマイホームを所有している方へ「購入時の自己資金（頭金）の割合」を質問したところ
          <strong
            >「自己資金はない」と回答した方が16.8%が最も多く、次いで自己資金1割未満と回答した方が16.6%という結果となり、3人に1人は「マイホーム購入時の自己資金1割未満」で購入</strong
          >していることがわかりました。
        </p>
        <p>少額の自己資金で、住宅購入する人も実は多いことが伺えます。</p>
      </div>
    </DirectionColumnIfMobileContainer>
  </ResearchDataCard>
</template>

<style lang="scss" module>
.container {
  :nth-child(n + 2) {
    margin-top: 8px;
  }
}
</style>
